export default __webpack_public_path__ + "static/media/capaOutros.6536bd2e.jpg";